import React from 'react';
import './App.css';
import Login from './components/Login/Login';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Matches from './components/Matches/Matches';
import * as actions from './redux/actions/auth';
import Leagues from './components/Leagues/Leagues';

class App extends React.Component {

  async componentDidMount(){
    await this.props.onAppLoad();
  }
  render() {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/matches">
            <Matches />
          </Route>
        <Route exact path="/leagues">
            <Leagues />
        </Route>
       </Switch>
        <Redirect to={this.props.authRedirectPath} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    authRedirectPath: state.auth.authRedirectPath,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    onAppLoad:()=>dispatch(actions.authCheckState()),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
